import { themeWorkspace } from "../../theme-node";

export function init() {
  return {
    kind: "category",
    name_universal: "geometry",
    name: "%{BKY_CATGEOMETRY}",
    colour: themeWorkspace.categoryStyles.geometry_category.colour,
    imageName: "/toolbox-imgs/shapes-solid.svg",
    id: "103",
    contents: [
      {
        kind: "label",
        text: "%{BKY_LABEL_DISPLAY}",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "variables_set",
        inline: false,
        fields: {
          VAR: {
            name: "graphic",
            type: "",
          },
        },
        inputs: {
          VALUE: {
            block: {
              type: "board_geometric",
              fields: {
                axes_type: "none",
                grid: false,
                showNavigation: false,
              },
              inputs: {
                xmin: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: -10,
                    },
                  },
                },
                xmax: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 10,
                    },
                  },
                },
                ymin: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: -10,
                    },
                  },
                },
                ymax: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 10,
                    },
                  },
                },
              },
            },
          },
        },
        next: {
          block: {
            type: "display_element",
            inputs: {
              object: {
                block: {
                  type: "variables_get",
                  fields: {
                    VAR: {
                      name: "graphic",
                      type: "",
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "draw_in_board",
        fields: {
          board_variable: {
            name: "graphic",
            type: "",
          },
        },
        inputs: {
          figure: {
            block: {
              type: "point",
              extraState: {
                displaymoreOptions: false,
              },
              fields: {
                moreOptions: false,
              },
              inputs: {
                name: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "A",
                    },
                  },
                },
                x: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 3,
                    },
                  },
                },
                y: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 3,
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "erase_in_board",
        fields: {
          figure_variable: {
            name: "figure",
            type: "",
          },
          board_variable: {
            name: "graphic",
            type: "",
          },
        },
      },
      {
        kind: "block",
        type: "erase_all_board",
        fields: {
          board_variable: {
            name: "graphic",
            type: "",
          },
        },
      },
      {
        kind: "label",
        text: "%{BKY_LABEL_OBJECTS}",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "point",
        extraState: {
          displaymoreOptions: false,
        },
        fields: {
          moreOptions: false,
        },
        inputs: {
          name: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "A",
              },
            },
          },
          x: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 3,
              },
            },
          },
          y: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 3,
              },
            },
          },
        },
      },
      /*
      {
        kind: "block",
        type: "glider",
        inputs: {
          name: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "A",
              },
            },
          },
          x: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 3,
              },
            },
          },
          y: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 3,
              },
            },
          },
          figure: {
            type: "Figure",
          },
        },
      },
  */
      {
        kind: "block",
        type: "line",
        fields: {
          type: "line",
        },
        inputs: {
          pointA: {
            block: {
              type: "point",
              extraState: {
                displaymoreOptions: false,
              },
              fields: {
                moreOptions: false,
              },
              inputs: {
                name: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "A",
                    },
                  },
                },
                x: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 5,
                    },
                  },
                },
                y: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 5,
                    },
                  },
                },
              },
            },
          },
          pointB: {
            block: {
              type: "point",
              extraState: {
                displaymoreOptions: false,
              },
              fields: {
                moreOptions: false,
              },
              inputs: {
                name: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "B",
                    },
                  },
                },
                x: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 15,
                    },
                  },
                },
                y: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 15,
                    },
                  },
                },
              },
            },
          },
        },
      },

      {
        kind: "block",
        type: "rectangle",
        inputs: {
          length: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 4,
              },
            },
          },
          width: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 2,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "regular_polygon",
        inputs: {
          point: {
            block: {
              type: "point",
              extraState: {
                displaymoreOptions: false,
              },
              fields: {
                moreOptions: false,
              },
              inputs: {
                name: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "O",
                    },
                  },
                },
                x: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 10,
                    },
                  },
                },
                y: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 10,
                    },
                  },
                },
              },
            },
          },
          sides: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 5,
              },
            },
          },
          radius: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 4,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "polygon",
        inputs: {
          vertices: {
            block: {
              type: "lists_create_with",
              extraState: {
                itemCount: 3,
              },
              inputs: {
                ADD0: {
                  block: {
                    type: "point",
                    extraState: {
                      displaymoreOptions: false,
                    },
                    fields: {
                      moreOptions: false,
                    },
                    inputs: {
                      name: {
                        shadow: {
                          type: "text",
                          fields: {
                            TEXT: "A",
                          },
                        },
                      },
                      x: {
                        shadow: {
                          type: "math_number",
                          fields: {
                            NUM: 5,
                          },
                        },
                      },
                      y: {
                        shadow: {
                          type: "math_number",
                          fields: {
                            NUM: 5,
                          },
                        },
                      },
                    },
                  },
                },
                ADD1: {
                  block: {
                    type: "point",
                    extraState: {
                      displaymoreOptions: false,
                    },
                    fields: {
                      moreOptions: false,
                    },
                    inputs: {
                      name: {
                        shadow: {
                          type: "text",
                          fields: {
                            TEXT: "B",
                          },
                        },
                      },
                      x: {
                        shadow: {
                          type: "math_number",
                          fields: {
                            NUM: 10,
                          },
                        },
                      },
                      y: {
                        shadow: {
                          type: "math_number",
                          fields: {
                            NUM: 15,
                          },
                        },
                      },
                    },
                  },
                },
                ADD2: {
                  block: {
                    type: "point",
                    extraState: {
                      displaymoreOptions: false,
                    },
                    fields: {
                      moreOptions: false,
                    },
                    inputs: {
                      name: {
                        shadow: {
                          type: "text",
                          fields: {
                            TEXT: "C",
                          },
                        },
                      },
                      x: {
                        shadow: {
                          type: "math_number",
                          fields: {
                            NUM: 15,
                          },
                        },
                      },
                      y: {
                        shadow: {
                          type: "math_number",
                          fields: {
                            NUM: 10,
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "random_polygon",
        inputs: {
          sides: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 3,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "circle",
        inputs: {
          point: {
            block: {
              type: "point",
              extraState: {
                displaymoreOptions: false,
              },
              fields: {
                moreOptions: false,
              },
              inputs: {
                name: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "O",
                    },
                  },
                },
                x: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 1,
                    },
                  },
                },
                y: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 1,
                    },
                  },
                },
              },
            },
          },
          radius: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 4,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "sector",
        inputs: {
          point1: {
            block: {
              type: "point",
              extraState: {
                displaymoreOptions: false,
              },
              fields: {
                moreOptions: false,
              },
              inputs: {
                name: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "A",
                    },
                  },
                },
                x: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 1.5,
                    },
                  },
                },
                y: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 5,
                    },
                  },
                },
              },
            },
          },
          point2: {
            block: {
              type: "point",
              extraState: {
                displaymoreOptions: false,
              },
              fields: {
                moreOptions: false,
              },
              inputs: {
                name: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "B",
                    },
                  },
                },
                x: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 1,
                    },
                  },
                },
                y: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 0.5,
                    },
                  },
                },
              },
            },
          },
          point3: {
            block: {
              type: "point",
              extraState: {
                displaymoreOptions: false,
              },
              fields: {
                moreOptions: false,
              },
              inputs: {
                name: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "C",
                    },
                  },
                },
                x: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 5,
                    },
                  },
                },
                y: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 3,
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "figure_clone",
      },
      {
        kind: "block",
        type: "board_text",
        inputs: {
          text: {
            block: {
              type: "text",
              fields: {
                TEXT: "Abc",
              },
            },
          },
          point: {
            block: {
              type: "point",
              extraState: {
                displaymoreOptions: false,
              },
              fields: {
                moreOptions: false,
              },
              inputs: {
                name: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "A",
                    },
                  },
                },
                x: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 2,
                    },
                  },
                },
                y: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 2,
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "label",
        text: "%{BKY_LABEL_TRANSFORMATIONS}",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "figure_translate",
        inputs: {
          x: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 3,
              },
            },
          },
          y: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 2,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "figure_rotate",
        inputs: {
          figure: {
            block: {
              type: "point",
              extraState: {
                displaymoreOptions: false,
              },
              fields: {
                moreOptions: false,
              },
              inputs: {
                name: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "A",
                    },
                  },
                },
                x: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 1,
                    },
                  },
                },
                y: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 1,
                    },
                  },
                },
              },
            },
          },
          angle: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 90,
              },
            },
          },
        },
      },
      {
        kind: "label",
        text: "%{BKY_LABEL_CALCULUSES}",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "coordinate",
        fields: {
          axis: "x",
          point_variable: {
            name: "point",
            type: "",
          },
        },
      },
      {
        kind: "block",
        type: "euclidean_distance_twopoints",
        inputs: {
          pointA: {
            block: {
              type: "point",
              extraState: {
                displaymoreOptions: false,
              },
              fields: {
                moreOptions: false,
              },
              inputs: {
                name: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "A",
                    },
                  },
                },
                x: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 1,
                    },
                  },
                },
                y: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 1,
                    },
                  },
                },
              },
            },
          },
          pointB: {
            block: {
              type: "point",
              extraState: {
                displaymoreOptions: false,
              },
              fields: {
                moreOptions: false,
              },
              inputs: {
                name: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "B",
                    },
                  },
                },
                x: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 2,
                    },
                  },
                },
                y: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 2,
                    },
                  },
                },
              },
            },
          },
        },
      },
      /* {
        kind: "block",
        type: "euclidean_distance",
        inputs: {
          x1: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          y1: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          x2: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          y2: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 3,
              },
            },
          },
        },
      },*/
      {
        kind: "block",
        type: "figure_perimeter",
      },
      {
        kind: "block",
        type: "figure_area",
      },
    ],
  };
}
